// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pjjZ","newExpiryDate":"styles_newExpiryDate__2G60h","footer":"styles_footer__2OjNV"};